import { render, staticRenderFns } from "./ModuleFormDraft.vue?vue&type=template&id=4d3c455a"
import script from "./ModuleFormDraft.vue?vue&type=script&lang=js"
export * from "./ModuleFormDraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports